import React, { useContext, useEffect, useMemo } from 'react';
import { useCurriculumDetailsQuery } from '../../../gql/hooks';
import { Translate } from 'app/services';
import { PageContainer, PageContent } from 'app/components/common';
import { LoadingPopup } from '../../common/learningListController/loadingPopup/LoadingPopup';
import { getDefaultCurriculumBanner } from '../../../const';
import LearningList from '../../common/learningList';
import './styles.less';
import Modal from 'antd/lib/modal/Modal';
import { InfoBanner } from '../../common/InfoBanner';
import ResourceList from '../../common/resourceList';
import { BreadcrumbContext, useBreadcrumbs } from '../../../breadcrumbs/BreadcrumbContext';
import { PaperIcon } from '@nackle/paper';
import { ACTIVE_THEME_NAME } from '../../../branding';
import { getString } from '@nackle/intl-tools';
import { Routes } from '../../../navigation';
import { Link } from '../../common';
import { CurriculumUtils } from '../../../utils';

export const CurriculumDetailsPage = ( props ) => {
    const curriculumId = useMemo( () => props?.route?.params?.curriculumId, [ props ] );

    const { data, loading: queryLoading, error } = useCurriculumDetailsQuery( curriculumId );

    const { leaveCrumb } = useContext( BreadcrumbContext );
    const breadcrumbs = useBreadcrumbs();

    useEffect( () => {
        if ( data?.name ) {
            leaveCrumb( props.pageKey, data.name );
        }
    }, [ data?.name ] );

    const courseList = useMemo( () => {
        if ( !data || !data.courses ) {return [];}

        if ( data.prerequisiteData?.locked ) {
            return data.courses.map( c => {
                const coursePrereq = c.prerequisiteData ?? {};
                coursePrereq.locked = true;
                return {
                    ...c,
                    prerequisiteData: coursePrereq,
                    blockClick: true
                };
            } );
        }

        return data.courses;
    }, [ data ] );

    const bannerImageUrl = useMemo( () => {
        if ( data ) {
            const url = CurriculumUtils.getHeroImageUrl( data );
            return url ? url : getDefaultCurriculumBanner( ACTIVE_THEME_NAME );
        } else {
            return undefined;
        }
    }, [ data ] );

    return (
        <PageContent className="page-curriculum-details">
            <LoadingPopup visible={ queryLoading } />
            
            { /* Banner */ }
            <PageContainer className="curriculum-details-banner-container">

            <InfoBanner
                title={ data?.name }
                parentTitle={ data?.categories?.length > 0 ? 
                    <>
                        <Translate.Text 
                            value="page.curriculumDetails.sections.categories.label" />
                        { data.categories.flatMap( ( c, i ) => ( [ ( i != 0 ? ',\u00A0' : '\u00A0' ), <Link key={ c.categoryId } push to={ Routes.CategoryDetails.buildPath( c.categoryId ) }>{ c.name }</Link> ] ) ) }
                    </> : null }
                percentComplete={ data?.progress } 
                hidePercentage={ data?.prerequisiteData?.locked }
                description={ data?.description }
                isLoading= { queryLoading } 
                locked={ data?.prerequisiteData?.locked }
                imageSrc={ bannerImageUrl }
                type='curriculum'
            /> 

            { !queryLoading && data &&
            <>
                { data.prerequisiteData?.locked && 
                    <div className='locked-content'>
                        <span>
                            <PaperIcon collection='ultimate' icon='Lock4' />
                            { data.prerequisiteData.operator == 'AND' 
                                ? <Translate.Text value='learningObject.locked.curriculum.all'/> 
                                : <Translate.Text value='learningObject.locked.curriculum.any'/> 
                            }                        
                            { data.prerequisiteData.prerequisites
                                .filter( r => !r.completed )
                                .flatMap( ( req, i ) => ( [ ( i != 0 ? ',\u00A0' : '\u00A0' ), <Link key={ req.id } push to={ req.link }>{ req.name }</Link> ] ) ) }

                        </span>
                    </div>  
                }
                <div className='curriculum-contents-section'>

                    { breadcrumbs }
                    <h4>
                        <Translate.Text className='title' value="page.curriculumDetails.sections.courses.header" />
                    </h4>
                    <LearningList
                        displayType='list'
                        learningType='course'
                        data={ courseList }
                        isLoading= { queryLoading } 
                    /> 
                    <ResourceList 
                        resourceIds={ data.lxp?.resourceIds }
                    />
                </div>
            </>
            }
                
            </PageContainer>
            <Modal
                className={ `${ ACTIVE_THEME_NAME } error-modal` }
                title={ error?.titleKey ? <h3>{ getString( error.titleKey ) }</h3> : '' }
                visible={ !!error }
                onOk={ () => {} }
                onCancel={ () => {} }
                closable={ false }
                footer={ <></> }
                >

                { error?.descriptionKey ? getString( error.descriptionKey ) : '' }
                
            </Modal>
       </PageContent>
    );
};
